(function(StoreLocator, $, undefined) {
  
  var addCustomLink = function() {
    var checkIfMap = setInterval(function() {
      if ($('#storemapper-left').length) {
        const $retailLinkContainer = $('<div />', { class: 'retail-link-container' });
        const $retailLinkHeading = $('<h1 />', { class: 'section-heading', text: 'Store Locator' });
        const $retailLink = $('<a />', { class: 'retail-link', href: 'https://soloshot.com/pages/contact-sales', text: 'Become a Retailer' });
        $retailLinkHeading.appendTo($retailLinkContainer)
        $retailLink.appendTo($retailLinkContainer);
        $('#storemapper-form').prepend($retailLinkContainer);
        clearInterval(checkIfMap);
      }
    }, 100);
  }

  StoreLocator.init = function() {
    addCustomLink();
  }

}(window.StoreLocator = window.StoreLocator || {}, jQuery));